export default {
  shadowSpread: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Shadow Spread",
      description: null
    },
    value: 7
  },
  cardPadding: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Padding",
      description: "Background"
    },
    value: 20
  },
  steppedLayoutIndentation: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Stepped layout indentation",
      description: "Set the indentation, in pixels, applied to row headers"
    },
    value: 12
  },
  rowPadding: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Row paddingh",
      description: "Padding in pixels applied to top and bottom of every row"
    },
    value: 2
  },
  borderThickness: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Border Thickness",
      description: null
    },
    value: 1
  },
  imageHeight: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Image height",
      description: "The height of images in pixels"
    },
    value: 100
  },
  textSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Text Size",
      description: null
    },
    value: 14
  },
  outlineWeight: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Outline weight",
      description: "Thickness of the outline in pixels"
    },
    value: 100
  },
  gridVerticalWeight: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      visible: 'gridVertical',
      displayName: "Vert grid thickness",
      description: "Thickness of the vertical gridlines in pixels"
    },
    value: 2
  },
  weight: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Weight",
      description: null
    },
    value: 3
  },
  roundEdge: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Round edges",
      description: null
    },
    value: 0
  },
  levelSubtitleFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Subtitle Font Size",
      description: null
    },
    value: 18
  },
  levelTitleFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Title Font Size",
      description: null
    },
    value: 20
  },
  gridHorizontalWeight: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      visible: 'gridHorizontal',
      displayName: "Horiz grid thickness",
      description: "Thickness of the horizontal gridlines in pixels"
    },
    value: 2
  },
  markerSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      visible: 'showMarker',
      displayName: "Marker size",
      description: null
    },
    value: 10
  },
  zoomLevel: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Zoom Level",
      description: null
    },
    value: 4
  },
  shadowDistance: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Distance",
      description: null
    },
    value: 4
  },
  centerLatitude: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Center Latitude",
      description: null
    },
    value: 43
  },
  centerLongitude: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Center Longitude",
      description: null
    },
    value: -83
  },
  maxMarginFactor: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      visible: 'showMarker',
      displayName: "Margin Factor(max)",
      description: null
    },
    value: 28
  },
  innerPadding: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Inner Padding",
      description: null
    },
    value: 22
  },
  strokeWidth: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Stroke width",
      description: null
    },
    value: 4
  },
  expandCollapseButtonsSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Collapse Buttons Size",
      description: null
    },
    value: 4
  },
  barWeight: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Bar thickness",
      description: "Thickness of the bar in pixels"
    },
    value: 2
  },
  shadowBlur: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Shadow Blur",
      description: null
    },
    value: 20
  },
  shadowDistance: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Shadow Distance",
      description: null
    },
    value: 10
  },
  bandsTransparency: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Bands Transparency",
      description: null
    },
    value: 20
  },
  dataBarWidthPercent: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Bar Width Percent",
      description: null
    },
    value: 120
  },
  dataLabelFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Label Font Size",
      description: null
    },
    value: 15
  },
  questionFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Question font size",
      description: null
    },
    value: 15
  },
  restatementFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Restatement font size",
      description: null
    },
    value: 15
  },
  headerFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Header font size",
      description: null
    },
    value: 15
  },
  cardFontSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Card font size",
      description: null
    },
    value: 15
  },
  xx: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "xx",
      description: null
    },
    value: 15
  },
  titleSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Title Font Size",
      description: null
    },
    value: 18
  },
  iconSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Icon Size",
      description: null
    },
    value: 15
  },
  barsPerLevel: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Bands Lavel",
      description: null
    },
    value: 20
  },
  angle: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Rotation",
      description: null
    },
    value: 0
  },
  max: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Max",
      description: null
    },
    value: 0
  },
  min: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Min",
      description: null
    },
    value: 0
  },
  filterRadius: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Max",
      description: null
    },
    value: 0
  },
  dataVolume: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Data Volume",
      description: null
    },
    value: 20
  },
  duration: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Duration",
      description: null
    },
    value: null
  },
  relativeRange: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Relative Range",
      description: null
    },
    value: null
  },
  relativePeriod: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Relative Period",
      description: null
    },
    value: null
  },
  headerSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Header Size",
      description: null
    },
    value: null
  },
  gridlineThickness: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      visible: 'gridlineShow',
      displayName: "Gridline Thickness",
      description: null
    },
    value: 2
  },
  percentageLabelPrecision: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "% decimal places",
      description: "Select the number of decimal places to display for the percentages"
    },
    value: null
  },
  start: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Start",
      description: "Enter a starting value (optional)"
    },
    value: true
  },
  end: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "End",
      description: "Enter an ending value (optional)"
    },
    value: null
  },
  labelPrecision: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Value decimal places",
      description: "Select the number of decimal places to display for the values"
    },
    value: "showTitleOnly"
  },
  innerRadiusRatio: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Inner Radius Ratio",
      description: null
    },
    value: 0
  },
  radius: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Border Radius",
      description: null
    },
    value: 0
  },
  target: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Target",
      description: null
    },
    value: 100
  },
  preferredCategoryWidth: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Minimum category width",
      description: null
    },
    value: null
  },
  bubbleSize: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Bubble Size",
      description: null
    },
    value: 0
  },
  secStart: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Start",
      description: "Enter a starting value (optional)"
    },
    value: 0
  },
  secEnd: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "End",
      description: "Enter an ending value (optional)"
    },
    value: 0
  },
  secLabelPrecision: {
    properties: {
      component: 'Numeric',
      type: "numeric",
      displayName: "Value decimal places",
      description: "Select the number of decimal places to display for the values"
    },
    value: 0
  },
}